module.exports = __webpack_public_path__ + "static/media/Deep_learning.732e7ecf.png";